export default {"src":"/_next/static/media/shield-lock.c06cf8b9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};